import React, {Component, Fragment} from 'react'
import {Breadcrumb, Card, Col, Row} from 'antd'
import style from '../style.css'
import {get} from 'lodash'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import StatementModal from '../Statements/StatementModal'
import TransactionModal from '../Statements/Transactions/Modals/TransactionModal'
import AccountView from './AccountView/View'

class Dashboard extends Component {
  render() {
    const {
      accounts,
      company,
      statement,
      transaction,
      fetch,
      fetching,
      onChangeCompany,
      visibleStatement,
      onCancelTransaction,
      visibleTransaction,
      onCancelStatement,
    } = this.props
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Finance</Breadcrumb.Item>
              <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Finance Overview</h2>
            <p className={style.paragraph}>
              View Companies bank accounts details.
            </p>
            <OrganisationsSelect
              value={company}
              style={{width: '50%'}}
              onChange={onChangeCompany}
            />
          </Row>
        </Card>
        <StatementModal
          statement={statement}
          key={'statement-modal'}
          visible={visibleStatement}
          onCancel={onCancelStatement}
          type={'edit'}
        />
        <TransactionModal
          transaction={transaction}
          key={'transaction-modal'}
          visible={visibleTransaction}
          onCancel={onCancelTransaction}
          type={'edit'}
        />
        <Card
          extra={<RefreshButton onClick={() => fetch(company)} />}
          title={<h2>Bank Accounts</h2>}
          loading={fetching}
          className={style.contentCard}>
          {accounts.map(account => (
            <Col span={10} offset={1}>
              <AccountView style={style} account={account} {...this.props} />
            </Col>
          ))}
        </Card>
      </Fragment>
    )
  }
}

Dashboard.propTypes = {}
Dashboard.defaultProps = {}

export default Dashboard
